import { Typography, useTheme } from '@mui/material'
import { FlexBoxProps, FlexGrowRow, FlexRow } from '@xylabs/sdk-react'
import numeral from 'numeral'
import { ReactElement } from 'react'
import { BiQuestionMark } from 'react-icons/bi'
import { GiEarthCrack, GiFactoryArm, GiProcessor, GiRadarDish, GiRollingEnergy } from 'react-icons/gi'
import { GoCircleSlash, GoPlus } from 'react-icons/go'

import CoinIcon from './CoinIcon'
import DataniumIcon from './DataniumIcon'
import Item from './Item'
import XyoIcon from './XyoIcon'

const ItemIcons: Record<string, ReactElement> = {
  'coin-unit': <CoinIcon />,
  'data-sink': <GiProcessor size={32} />,
  'datanium-unit': <DataniumIcon />,
  'energy-dish': <GiRadarDish size={32} />,
  'energy-unit': <GiRollingEnergy size={32} />,
  'matter-mill': <GiFactoryArm size={32} />,
  'matter-unit': <GiEarthCrack size={32} />,
  'xyo-unit': <XyoIcon />,
}

interface Props extends FlexBoxProps {
  disabled?: boolean
  item?: Item
}

const ItemViewer: React.FC<Props> = (props) => {
  const { disabled = false, item, ...boxProps } = props

  const icon = item?.moniker ? ItemIcons[item?.moniker] : <BiQuestionMark size={32} />

  const theme = useTheme()

  return (
    <FlexRow paper border="solid 1px" height={64} width={64} position="relative" {...boxProps}>
      {item ? <FlexGrowRow>{icon}</FlexGrowRow> : null}
      {disabled ? (
        <FlexGrowRow style={{ opacity: 0.2 }}>
          <GoCircleSlash size={32} />
        </FlexGrowRow>
      ) : item === undefined ? (
        <FlexGrowRow style={{ opacity: 0.8 }}>
          <GoPlus size={32} />
        </FlexGrowRow>
      ) : null}
      {item?.quantity !== undefined ? (
        <FlexRow height={24} position="absolute" style={{ opacity: 0.75 }} bottom={0} right={0} bgcolor={theme.palette.secondary.main} paddingX={1}>
          <Typography noWrap={true} variant="caption">
            {numeral(item?.quantity).format('0.a')}
          </Typography>
        </FlexRow>
      ) : null}
    </FlexRow>
  )
}

export default ItemViewer
